module.exports = __webpack_public_path__ + "Images/loading.gif";


//////////////////
// WEBPACK FOOTER
// ./Images/loading.gif
// module id = 1870
// module chunks = 2